import React from 'react';
import { RMAXLogger } from '@RMAXLogger';
import { withStyles, Grid, InputAdornment, TextField, Tab, Tabs } from '@material-ui/core';
import EditCustomerMap from './map';
import Select from '../../../common/StyledSelect';
import { postData, getDataWithQueryString } from '../../../../api/componentAPIs';
import { withUserProfile } from '../../../../userProfile/userProfileContext';
import MESSAGES from '../../../../appMessages';
import { compose } from 'recompose';
import styles from './styles';
import { withSnackbar } from 'notistack';
import { observer, inject } from 'mobx-react';
import { areIntervalsOverlapping } from 'date-fns';
import { formatAddress, isValidEmail } from '../../Dispatch/utils/utils';
import CustomCheckboxGroupRendered from '../../Dispatch/RouteExecution/DriverPopUp/common/CheckboxGroup';
import { closedDayTime } from './components/ReceivingHours';
import { AppLoading } from '../../../../loaders/loaders';
import Events from '../../../../utilities/EventEmitter';
import { withAppConfig } from '../../../../appConfigContext';
import { withFeatureFlags } from '@withFeatureFlags';
import WithDrawer from '../../Dispatch/Common/Drawer/WithDrawer';
import drawConstant from '../../Settings/common/DrawTools/DrawConstant';
import { isLocationWithinGeoFence } from './map/utils';
import {
  getDefaultCustomerErrorInfo,
  getNoFMECustomerErrorInfo,
  isDeliveryTab,
  getHolidayOptions,
  processDefaultHours,
  getEquipmentPayloadData,
  isPickupTab,
  getInitialDeliveryDetails,
  getInitialPickupDetails,
  getPhoneNumberErrorInfo,
  getCustomerDetailsKey,
  getADNPayload,
  shouldSendPhysicalDrPreferenceInCustomerUpdate,
} from './utils';
import GeoCodingModal from '../../Common/Geocoding/GeoCodingModal';
import { getCustomerManagementGeocodingData } from '../../Common/Geocoding/utils';
import Header from './components/Header';
import InfoHeader from './components/InfoHeader';
import Action from './components/Action';
import ResizableSplitLayout from '../../../common/ResizableSplitLayout';
import appConstants from '@appConstants';
import DayofWeekHoursInput from './components/DayofWeekHoursInput';
import ReceivingHoursRenderer from './components/ReceivingHoursRenderer';
import Holidays from './components/Holidays';
import DriverComments from './components/DriverComments';
import Aliases from './components/Aliases';
import {
  buildDriverCommentsQueryString,
  normalizeDriverComments
} from './components/DriverComments/utils';
import { driverCommentsConstants } from './components/DriverComments/constants';
import Appointment from './components/Appointment';
import {
  APPOINTMENT_TYPES,
  CONTACT_SECTION_TITLES,
  CUSTOMER_DETAILS,
  EDIT_CUSTOMER_FORM_MAP_SPLIT_LAYOUT
} from './constants';
import { FORM_VALIDATION_MSG } from '../../Dispatch/RouteExecution/Pickups/PickupManagement/constants';
import Receivers from './components/Receivers';
import EquipmentDetails from './components/EquipmentDetails';
import SectionHeader from './components/SectionHeader';
import { isEquipmentUpdateValid } from '../MarkLocation/utils';
import CustomCheckbox from '../../Dispatch/RouteExecution/DriverPopUp/common/CustomCheckbox';
import CustomSwitch from '../../Dispatch/RouteExecution/DriverPopUp/common/CustomSwitch';
import ContactDetails from './components/ContactDetails';
import DeliveryInstructions from './components/DeliveryInstructions';
import Notes from './components/Notes';
import AdvanceDeliveryNotification from './components/AdvanceDeliveryNotification';
import {
  buildCustomerGeoFenceQueryString,
  getGeoFenceFromResponse
} from '../../Common/GeoFence/utils';

const DAYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'];

// TODO: add route field, validation & send on update
@inject('IBPlanningStore', 'CommonStore')
@observer
class CustomerManagementDialog extends React.Component {
  constructor(props) {
    super(props);
    this.defaultReceivingHours = DAYS.reduce((receivingHours, day) => {
      receivingHours[day] = [''];
      return receivingHours;
    }, {});
    this.state = {
      dataLoaded: false,
      data: null,
      address: '',
      selectedRoute: null,
      customerRoutes: [],
      updatePending: false,
      customerGeoFencing: null,
      geoCodeCustomer: null,
      activeTab: this.props.activeTabLabel || appConstants.CUSTOMER_TAB_TYPE.DELIVERY,
      enableTrailerBackFillCustomer: this.props.configJSON?.enableTrailerBackFillCustomer,
      [CUSTOMER_DETAILS.DELIVERY]: {
        receivingHours: this.defaultReceivingHours,
        errorInfo: getDefaultCustomerErrorInfo(),
      },
      [CUSTOMER_DETAILS.PICKUP]: {
        shippingHours: this.defaultReceivingHours,
        errorInfo: {
          ...getDefaultCustomerErrorInfo(),
          noFMECustomer: undefined
        },
      },
      driverComments: null,
      hasFetchedDriverComments: false,
      isDriverCommentsLoading: false
    };
    this.contactDetailsReference = {
      delivery: {
        contactName: '',
        phoneNumber: ''
      },
      pickup: {
        contactName: '',
        phoneNumber: ''
      }
    };
    this.terminalId = this.props.userData.userProfile.terminal.id;
    this.originalGeoFenced = null;
    this.gridHeaderId = 'editCustomer';
    this.timeoutId = null;
    this.isAppointmentEnabled = 
      props.configJSON.enableRequiresAppointmentInCustomerManagement || 
      props.configJSON.enableIgnoreAppointmentInCustomerManagement;
  }

  get isADNEnabled() {
    return this.props.configJSON?.enableAdvanceDeliveryNotificationInIBPlanning;
  }

  get enableTailLoadInCustomerManagement() {
    return this.props.featureFlags?.isFeatureEnabled(
      appConstants.features.EnableTailLoadInCustomerManagement
    );
  }

  componentDidMount() {
    this.props.glEventHub.on(`${this.gridHeaderId}_geocode`, this.onGeocodeCustomer);
    this.getCustomerRoutes();
    this.fetchHolidays();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.userData.userProfile.terminal.id !== prevProps.userData.userProfile.terminal.id
    ) {
      this.fetchHolidays();
    }
  }

  componentWillUnmount() {
    this.props.glEventHub.off(`${this.gridHeaderId}_geocode`, this.onGeocodeCustomer);
    this.timeoutId && clearTimeout(this.timeoutId);
  }

  fetchHolidays = async () => {
    const holidayOptions = await getHolidayOptions({
      enqueueSnackbar: this.props.enqueueSnackbar,
      terminalId: this.props.userData.userProfile.terminal.id
    });
    this.props.IBPlanningStore.setHolidayOptions(holidayOptions);
  };

  onGeocodeCustomer = () => {
    this.setState({
      geoCodeCustomer: getCustomerManagementGeocodingData(
        this.state.data,
        this.state.data?.deliveryDetails?.customerId
          ? appConstants.CUSTOMER_TYPE.DELIVERY
          : appConstants.CUSTOMER_TYPE.PICKUP
      )
    });
  };

  closeGeocodeModal = (hasGeoDataChanged = false) => {
    if (hasGeoDataChanged) {
      this.getCustomerManagementData(hasGeoDataChanged, true);
    }
    this.setState({ geoCodeCustomer: null });
  };

  refreshCustomerData = (customerData) => {
    Events.emit('updateCustomersData', [this.props.customerCode], customerData);
  };

  getCustomerManagementData = (
    shouldUpdateCustomerDataInGrid = false,
    shouldRefreshGeoFenceData = false
  ) => {
    getDataWithQueryString(
      'GetCustomerDetail',
      `terminalId=${this.terminalId}&customerCodes=${this.props.customerCode}`
    ).then(
      (response) => {
        if (response.status === 200 && response.data.length === 1) {
          const customerData = response.data[0];
          const { address, address2, city, state, zip, deliveryDetails, pickupDetails } =
            customerData;
          const { enableFixedEquipmentSize } = this.props.configJSON;
          this.setState((prevState) => ({
            data: customerData,
            address: formatAddress({
              address: `${address} ${address2 ?? ''}`.trim(),
              city,
              state,
              zip
            }),
            selectedRoute: customerData.deliveryDetails?.route || null,
            isTrailerBackFill: deliveryDetails?.isTrailerBackFill,
            isTailLoad: deliveryDetails?.isTailLoad,
            pickupDetails: {
              ...this.state.pickupDetails,
              ...pickupDetails,
              ...getInitialPickupDetails({
                pickupDetails,
                prevReceivingHours: prevState.pickupDetails?.shippingHours,
                enableFixedEquipmentSize,
                enableTrailerSwap: this.props.configJSON.enableTrailerSwapInShippersPopup
              })
            },
            deliveryDetails: {
              ...this.state.deliveryDetails,
              ...deliveryDetails,
              ...getInitialDeliveryDetails({
                deliveryDetails,
                prevReceivingHours: prevState.receivingHours,
                enableFixedEquipmentSize,
                featureFlags: {
                  enableNonLGCustomer: this.props.configJSON.enableNonLGCustomer
                }
              })
            },
            adnToggleEnabled: Boolean(deliveryDetails?.emailForAdvanceDeliveryNotification),
            adnEmail: deliveryDetails?.emailForAdvanceDeliveryNotification || ''
          }));
          this.adnExistingEmail = deliveryDetails?.emailForAdvanceDeliveryNotification || '';
          this.contactDetailsReference = {
            delivery: {
              contactName: deliveryDetails?.contactName ?? '',
              phoneNumber: deliveryDetails?.phoneNumber ?? ''
            },
            pickup: {
              contactName: pickupDetails?.shipperContactName ?? '',
              phoneNumber: pickupDetails?.phoneNumber ?? ''
            }
          };
          shouldRefreshGeoFenceData &&
            this.getCustomerGeoFence(
              customerData.deliveryDetails?.originalCustomerCode ??
                customerData.code,
              customerData.pickupDetails?.rmaxShipperCode,
            );
          shouldUpdateCustomerDataInGrid && this.refreshCustomerData(customerData);
        } else {
          this.handleGetCustomerDataError();
        }
      },
      (error) => {
        this.handleGetCustomerDataError();
      }
    );
  };

  getCustomerRoutes = () => {
    getDataWithQueryString('GetCustomerRoutes', `terminalId=${this.terminalId}`).then(
      (response) => {
        if (response.status === 200 && response.data.length > 0) {
          const customerRoutes = response.data
            .sort((value1, value2) => value1 - value2)
            .map((routeName) => ({ label: routeName, value: routeName }));
          this.setState((prevState) => ({
            customerRoutes
          }));
        } else {
          this.setState({
            customerRoutes: [],
            selectedRoute: null
          });
        }
        this.getCustomerManagementData(false, true);
      },
      (error) => {
        this.props.enqueueSnackbar(MESSAGES.CUSTOMER_MANAGEMENT.GET_CUSTOMER_ROUTES_FAILURE, {
          variant: 'error'
        });
        this.setState({
          customerRoutes: [],
          selectedRoute: null
        });
        this.getCustomerManagementData(false, true);
      }
    );
  };

  handleCustomerGeoFenceFetchFailure = () => {
    this.originalGeoFenced = null;
    this.setState({ customerGeoFencing: null });
    this.props.enqueueSnackbar(MESSAGES.COMMON.CUSTOMER_GEOFENCE_FETCH_FAILED, {
      variant: 'error'
    });
  };

  getCustomerGeoFence = (customerCode, rmaxShipperCode) => {
    const queryString = buildCustomerGeoFenceQueryString({
      terminalId: this.terminalId,
      customerCode,
      rmaxShipperCode
    });
    getDataWithQueryString('GetCustomerGeoFence', queryString).then(
      (response) => {
        if (response?.status >= 200 && response?.status < 400) {
          const geoFence = getGeoFenceFromResponse(response);
          this.originalGeoFenced = geoFence;
          this.setState(
            {
              customerGeoFencing: geoFence
            },
            () => {
              if (geoFence) {
                this.selectGeoFenceOnMap(this.state.data.deliveryDetails?.customerId);
              }
            }
          );
          return;
        }
        this.handleCustomerGeoFenceFetchFailure();
      },
      this.handleCustomerGeoFenceFetchFailure
    );
  };

  selectGeoFenceOnMap = (customerId) => {
    //need some delay to select drawing so added this code
    // it will take some time to load and draw already exist geofencing after that only we can create.
    //we can remove this settime out if we find better solution
    this.timeoutId = setTimeout(() => {
      Events.emit(
        drawConstant.ROUTE_MAPPING_EVENTS.DRAWING_SELECTED_ON_SIDE_PANEL,
        [customerId],
        true
      );
    }, 0);
  };

  customerGeoFencingChange = (customerGeoFencing) => {
    if (customerGeoFencing !== this.state.customerGeoFencing) {
      this.setState({
        customerGeoFencing: customerGeoFencing
      });
      if (customerGeoFencing) {
        this.selectGeoFenceOnMap(this.state.data.deliveryDetails?.customerId);
      }
      this.checkCustomerLocationWithFencing(JSON.parse(customerGeoFencing));
    }
  };

  checkCustomerLocationWithFencing = (customerGeoFencing) => {
    const { data } = this.state;
    const location = data
      ? {
          latitude: data.latitude,
          longitude: data.longitude
        }
      : null;
    const locationNotWithinGeoFence = !isLocationWithinGeoFence(customerGeoFencing, location);
    if (locationNotWithinGeoFence) {
      this.props.enqueueSnackbar('Customer location should be inside the geofence.', {
        variant: 'error'
      });
    }
    this.setState({
      updatePending: locationNotWithinGeoFence
    });
  };

  handleGetCustomerDataError = () => {
    this.props.enqueueSnackbar(MESSAGES.CUSTOMER_MANAGEMENT.GET_FAILURE, {
      variant: 'error'
    });
    this.props.handleClose();
  };

  filterNullableValues = (receivingHours) => {
    return (
      receivingHours &&
      Object.keys(receivingHours).reduce((hours, key) => {
        const prevHours = receivingHours[key];
        hours[key] = prevHours.length > 1 ? prevHours.filter(Boolean) : prevHours;
        hours[key] = hours[key].length ? hours[key] : [''];
        return hours;
      }, {})
    );
  };

  cleanData = () => {
    this.setState(
      (prevState) => ({
        deliveryDetails: {
          ...prevState.deliveryDetails,
          receivingHours: this.filterNullableValues(prevState.deliveryDetails?.receivingHours)
        },
        ...(prevState.pickupDetails && {
          pickupDetails: {
            ...prevState.pickupDetails,
            shippingHours: this.filterNullableValues(prevState.pickupDetails?.shippingHours)
          }
        })
      }),
      this.saveCustomerData
    );
  };

  updateCustomerData = () => {
    this.cleanData(this.saveCustomerData);
  };

  getFormattedAccessorials = (accessorialList) => {
    return accessorialList.reduce((accesorialObject, accesorial) => {
      accesorialObject[accesorial.name] = accesorial.isChecked;
      return accesorialObject;
    }, {});
  };

  getFormattedDeliveryInstructions = (isDelivery) => {
    const field = isDelivery ? 'deliveryDetails' : 'pickupDetails';
    const { isDeliveryProofRequired, isUnattendedDelivery, isPhysicalDrRequired } = this.state[field] || {};
    const { enableProofOfDeliveryInCustomerManagement, enableUnattendedDeliveryInCustomerManagement } = this.props.configJSON || {};
    
    const result = {};
    
    if (enableProofOfDeliveryInCustomerManagement) {
      result.isDeliveryProofRequired = Boolean(isDeliveryProofRequired);
    }
    
    if (enableUnattendedDeliveryInCustomerManagement) {
      result.isUnattendedDelivery = Boolean(isUnattendedDelivery);
    }
    
    if (shouldSendPhysicalDrPreferenceInCustomerUpdate(this.props.configJSON, isDelivery)) {
      result.isPhysicalDrRequired = Boolean(isPhysicalDrRequired);
    }
    
    return result;  
  };

  saveCustomerData = () => {
    if (!this.isDataValid()) {
      return;
    }

    const {
      selectedRoute,
      customerGeoFencing,
      data,
      isTrailerBackFill,
      isTailLoad,
      deliveryDetails: {
        receivingHours,
        accessorialList: deliveryAccessorialList,
        defaultHours: deliveryDefaultHours,
        stopTime: deliveryStopTime,
        noFMECustomerOptions,
        noCargoVanCustomerOptions,
        equipmentDetails,
        appointmentValue,
        minimumHUValue
      },
      pickupDetails: {
        rmaxShipperCode,
        shippingHours = null,
        accessorialList: pickupAccessorialList,
        defaultHours: pickupDefaultHours,
        stopTime: pickupStopTime,
        equipmentDetails: pickupEquipmentDetails
      }
    } = this.state;
    const {
      enableNoCargoVanCustomer,
      enableFMECustomer,
      enableFixedEquipmentSize,
      enableCommentsForCustomer
    } = this.props.configJSON;
    const inputObj = {
      terminalId: this.terminalId,
      ...(data?.deliveryDetails && {
        deliveryDetails: {
          code: data.deliveryDetails.originalCustomerCode,
          isTrailerBackFill: Boolean(this.state.enableTrailerBackFillCustomer && isTrailerBackFill),
          ...(this.enableTailLoadInCustomerManagement && { isTailLoad: Boolean(isTailLoad) }),
          receivingHours,
          ...processDefaultHours(deliveryDefaultHours),
          ...getEquipmentPayloadData({
            enableFixedEquipmentSize,
            equipmentDetails
          }),
          stopTime: deliveryStopTime ? Number(deliveryStopTime) : null,
          ...(enableFMECustomer && {
            isNoFME: noFMECustomerOptions[0]?.isChecked
          }),
          ...(enableNoCargoVanCustomer && {
            isNoCargoVan: noCargoVanCustomerOptions[0]?.isChecked
          }),
          route: selectedRoute,
          isApt: appointmentValue === APPOINTMENT_TYPES.REQUIRES_APT,
          isIgnoreApt: appointmentValue === APPOINTMENT_TYPES.IGNORE_APT,
          minHuForApt: minimumHUValue,
          ...this.getFormattedAccessorials(deliveryAccessorialList),
          ...this.populateContactDetails(),
          ...this.getFormattedDeliveryInstructions(true),
          ...(enableCommentsForCustomer && {
            customerComments: this.state.deliveryDetails.customerComments || null
          }),
          ...this.getADNPayload()
        }
      }),
      ...(data?.pickupDetails &&
        this.props.configJSON?.showShippersInCustomerManagement && {
          pickupDetails: {
            rmaxShipperCode,
            ...processDefaultHours(pickupDefaultHours),
            shippingHours,
            ...getEquipmentPayloadData({
              enableFixedEquipmentSize,
              equipmentDetails: pickupEquipmentDetails
            }),
            stopTime: pickupStopTime ? Number(pickupStopTime) : null,
            ...this.getFormattedAccessorials(pickupAccessorialList),
            openHours2: undefined, //not required for shipper updates
            closeHours2: undefined,
            ...this.populateContactDetails(true),
            ...this.getFormattedDeliveryInstructions(false),
            ...(enableCommentsForCustomer && {
              shipperComments: this.state.pickupDetails.shipperComments || null
            })
          }
        })
    };

    if (this.originalGeoFenced !== customerGeoFencing) {
      inputObj.deliveryDetails.geoFence = customerGeoFencing;
    }

    this.setState({
      updatePending: true
    });
    postData('UpdateCustomerDetail', inputObj)
      .then((response) => {
        if (response && Math.trunc(response.status / 100) === 2) {
          this.props.enqueueSnackbar(MESSAGES.CUSTOMER_MANAGEMENT.SUCCESS, {
            variant: 'success'
          });
          this.setState({
            updatePending: false
          });
          this.refreshCustomerData();
          Events.emit(appConstants.Event.RESTOREIBSTORE);
          this.props.handleClose();
        } else {
          this.handleError(response.status);
        }
      })
      .catch(() => {
        this.handleError();
      });
  };

  populateContactDetails = (isPickup) => {
    const contactDetails = isPickup ? this.state.pickupDetails : this.state.deliveryDetails;
    const originalContactDetails = this.contactDetailsReference[isPickup ? 'pickup' : 'delivery'];

    let finalDetails = {};
    const fields = ['phoneNumber', 'contactName'];
    fields.forEach((field) => {
      const originalValue = originalContactDetails[field];

      if (isPickup && field === 'contactName') field = 'shipperContactName';
      const newValue = contactDetails[field];

      // Check if either value exists and if they are different
      if ((originalValue || newValue) && newValue !== originalValue) {
        finalDetails[field] = newValue || null; // Use null if newValue is undefined
      }
    });
    return finalDetails;
  };

  isDataValid = () => {
    const {
      pickupDetails,
      deliveryDetails: { defaultHours, noFMECustomerOptions, receivingHours, equipmentDetails }
    } = this.state;
    const deliveryErrorInfo = this.state.deliveryDetails.errorInfo;

    // Validate delivery details
    let receivingHoursHasError = false;
    if (this.state.data.deliveryDetails) {
      deliveryErrorInfo.defaultHours = receivingHours?.length
        ? ['']
        : [...this.getDayReceivingHourError(defaultHours)];
      if (!isEquipmentUpdateValid(equipmentDetails)) {
        this.props.enqueueSnackbar(MESSAGES.EQUIPMENT.INVALID_UPDATE['maxEquipmentSize'], {
          variant: 'error'
        });
        return;
      }
      if (Boolean(receivingHours)) {
        deliveryErrorInfo.receivingHours = this.getreceivingHoursError(
          this.state.deliveryDetails?.receivingHours
        );
        receivingHoursHasError = Boolean(
          Object.keys(deliveryErrorInfo.receivingHours).filter(
            (day) => deliveryErrorInfo.receivingHours[day].filter(Boolean).length
          ).length
        );
      }
      if (this.props.configJSON.enableFMECustomer) {
        deliveryErrorInfo.noFMECustomer = getNoFMECustomerErrorInfo({
          noFMECustomerOptions: noFMECustomerOptions[0]?.isChecked,
          equipmentDetails
        });
      }
      deliveryErrorInfo.phoneNumber = getPhoneNumberErrorInfo(this.state.deliveryDetails);

      deliveryErrorInfo.adnEmail = this.getADNEmailError(this.state.adnEmail);
    }

    // Validate pickup details
    let shippingHoursHasError = false;
    const pickupErrorInfo = pickupDetails.errorInfo;
    if (this.state.data.pickupDetails && this.props.configJSON?.showShippersInCustomerManagement) {
      const pickupDefaultHours = pickupDetails.defaultHours;
      pickupErrorInfo.defaultHours = pickupDetails?.shippingHours?.length
        ? ['']
        : [...this.getDayReceivingHourError(pickupDefaultHours)];

      if (Boolean(pickupDetails.shippingHours)) {
        pickupErrorInfo.shippingHours = this.getreceivingHoursError(pickupDetails.shippingHours);
        shippingHoursHasError = Boolean(
          Object.keys(pickupErrorInfo.shippingHours).filter(
            (day) => pickupErrorInfo.shippingHours[day].filter(Boolean).length
          ).length
        );
      }
      pickupErrorInfo.phoneNumber = getPhoneNumberErrorInfo(this.state.pickupDetails)
    }
    const deliveryHasError =
      (Boolean(receivingHours)
        ? receivingHoursHasError
        : deliveryErrorInfo.defaultHours?.some(Boolean)) || deliveryErrorInfo.noFMECustomer || deliveryErrorInfo.phoneNumber || deliveryErrorInfo.adnEmail;

    const pickupHasError =
      (Boolean(pickupDetails?.shippingHours)
        ? shippingHoursHasError
        : pickupErrorInfo.defaultHours?.some(Boolean)) || pickupErrorInfo.phoneNumber;
        
    const hasError = Boolean(deliveryHasError || pickupHasError);
    let tabToSwitchToOnError = this.state.activeTab;
    if (hasError) {
      tabToSwitchToOnError = deliveryHasError
        ? appConstants.CUSTOMER_TAB_TYPE.DELIVERY
        : appConstants.CUSTOMER_TAB_TYPE.PICKUP;
    }
    this.setState((state) => ({
      deliveryDetails: {
        ...state.deliveryDetails,
        errorInfo: deliveryErrorInfo
      },
      pickupDetails: {
        ...state.pickupDetails,
        errorInfo: pickupErrorInfo
      },
      ...(hasError ? { activeTab: tabToSwitchToOnError } : {})
    }));
    return !hasError;
  };

  handleError = (statusCode) => {
    this.setState({
      updatePending: false
    });
    if (statusCode === 403) {
      return;
    }
    this.props.enqueueSnackbar(MESSAGES.CUSTOMER_MANAGEMENT.FAILURE, {
      variant: 'error'
    });
  };

  handleNoteChange = (value) => {
    if (this.state.activeTab === appConstants.CUSTOMER_TYPE.DELIVERY) {
      this.setState((prevState) => ({
        ...prevState,
        deliveryDetails: {
          ...prevState.deliveryDetails,
          customerComments: value,
        },
      }));
      return;
    }
    this.setState((prevState) => ({
      ...prevState,
      pickupDetails: {
        ...prevState.pickupDetails,
        shipperComments: value,
      },
    }));
  };


  getreceivingHoursError = (receivingHours) => {
    const receivingHoursError = {};
    Object.keys(receivingHours).forEach((day) => {
      receivingHoursError[day] = this.getDayReceivingHourError(receivingHours[day]);
    });
    return receivingHoursError;
  };

  getDayReceivingHourError = (receivingHours) => {
    if (receivingHours.filter(Boolean).length < 1) {
      return ['* Required'];
    }
    return receivingHours.filter(Boolean).length === 1
      ? ['']
      : [
          '',
          this.checkIfOverLappingTime(receivingHours[0], receivingHours[1])
            ? '* Time overlapping is not allowed'
            : ''
        ];
  };

  getStartEndTime = (newTime) => {
    const [startTime, endTime] = newTime.split('-');
    const [startHour, startMinute] = startTime.split(':');
    const [endHour, endMinute] = endTime.split(':');
    return {
      start: new Date(0, 0, 0, startHour, startMinute),
      end: new Date(0, 0, 0, endHour, endMinute)
    };
  };

  isValidTimeInterval = (timeString) => {
    if (!timeString || typeof timeString !== 'string') {
      return false;
    }
    const interval = this.getStartEndTime(timeString);
    return interval.start <= interval.end;
  };

  resetToDefaultHours = () => {
    if (isDeliveryTab(this.state.activeTab)) {
      this.setState((prevState) => ({
        deliveryDetails: {
          ...prevState.deliveryDetails,
          receivingHours: null
        }
      }));
      return;
    }
    this.setState((prevState) => ({
      pickupDetails: {
        ...prevState.pickupDetails,
        shippingHours: null
      }
    }));
  };

  checkIfOverLappingTime(firstWindow, secondWindow) {
    if (!this.isValidTimeInterval(firstWindow) || !this.isValidTimeInterval(secondWindow)) {
      return false;
    }
    return areIntervalsOverlapping(
      this.getStartEndTime(firstWindow),
      this.getStartEndTime(secondWindow)
    );
  }

  updateHours = (day, hours) => {
    if (isDeliveryTab(this.state.activeTab)) {
      this.setState((prevState) => ({
        deliveryDetails: {
          ...prevState.deliveryDetails,
          receivingHours: {
            ...prevState.deliveryDetails.receivingHours,
            [day]: hours
          },
          errorInfo: {
            ...prevState.deliveryDetails.errorInfo,
            receivingHours: {
              ...prevState.deliveryDetails.errorInfo.receivingHours,
              [day]: this.getDayReceivingHourError(hours)
            }
          }
        }
      }));
      return;
    }
    this.updateShippingHours(day, hours);
  };

  updateShippingHours = (day, hours) => {
    this.setState((prevState) => ({
      pickupDetails: {
        ...prevState.pickupDetails,
        shippingHours: {
          ...prevState.pickupDetails.shippingHours,
          [day]: hours
        },
        errorInfo: {
          ...prevState.pickupDetails.errorInfo,
          shippingHours: {
            ...prevState.pickupDetails.errorInfo.shippingHours,
            [day]: this.getDayReceivingHourError(hours)
          }
        }
      }
    }));
  };

  updateEquipmentSize = (field) => (value) => {
    const equipmentSize = value?.label ?? null;
    const stateKey = getCustomerDetailsKey(this.state.activeTab);
    const { equipmentDetails } = this.state[stateKey];
    
    const equipmentUpdateDetails = {
      ...equipmentDetails,
      [equipmentDetails.equipmentType]: {
        ...equipmentDetails[equipmentDetails.equipmentType],
        [field]: equipmentSize
      }
    };

    this.setState((prevState) => ({
      [stateKey]: {
        ...prevState[stateKey],
        equipmentDetails: equipmentUpdateDetails,
        errorInfo: {
          ...prevState[stateKey].errorInfo,
          ...(isDeliveryTab(this.state.activeTab) && {
            noFMECustomer: getNoFMECustomerErrorInfo({
              noFMECustomerOptions: prevState.deliveryDetails.noFMECustomerOptions[0]?.isChecked,
              equipmentDetails: equipmentUpdateDetails
            })
          })
        }
      }
    }));
  };

  clearEquipmentPreference = () => {
    const equipmentUpdateDetails = {
      equipmentType: null,
      Fixed: {
        fixedEquipmentSize: null
      },
      Flexible: {
        minEquipmentSize: null,
        maxEquipmentSize: null
      }
    };
    const stateKey = getCustomerDetailsKey(this.state.activeTab);
    
    this.setState((prevState) => ({
      [stateKey]: {
        ...prevState[stateKey],
        equipmentDetails: equipmentUpdateDetails
      }
    }));
  };

  updateStopTime = (event) => {
    const fieldName = getCustomerDetailsKey(this.state.activeTab);
    const stopTime = event.target.value === '' ? null : event.target.value;
    this.setState((prevState) => ({
      [fieldName]: {
        ...prevState[fieldName],
        stopTime
      }
    }));
  };

  updateRoute = (value) => {
    const selectedRoute = value?.label ?? null;
    const customerRoutes = value?.__isNew__
      ? this.state.customerRoutes
          .filter((option) => !Boolean(option.__isNew__))
          .concat(value)
          .sort((option1, option2) => option1.label - option2.label)
      : this.state.customerRoutes;

    this.setState({
      customerRoutes,
      selectedRoute
    });
  };

  updateDefaultHours = (hours) => {
    const fieldName = getCustomerDetailsKey(this.state.activeTab);
    this.setState((state) => ({
      [fieldName]: {
        ...state[fieldName],
        defaultHours: hours,
        errorInfo: {
          ...state[fieldName].errorInfo,
          defaultHours: this.getDayReceivingHourError(hours)
        }
      }
    }));
  };

  getRequiredError = (value = null) => {
    return value !== null ? '' : '* Required';
  };

  updateAccessorials = (updatedAccessorials) => {
    const fieldName = getCustomerDetailsKey(this.state.activeTab);
    this.setState((state) => ({
      [fieldName]: {
        ...state[fieldName],
        accessorialList: updatedAccessorials
      }
    }));
  };

  updateTrailerBackfill = (e) => {
    this.setState({
      isTrailerBackFill: e.target.checked
    });
  };

  updateTailLoad = (e) => {
    this.setState({
      isTailLoad: e.target.checked
    });
  };

  onChangeNoFMECustomer = (noFMECustomerOptions) => {
    this.setState((prevState) => ({
      deliveryDetails: {
        ...prevState.deliveryDetails,
        noFMECustomerOptions,
        errorInfo: {
          ...prevState.deliveryDetails.errorInfo,
          noFMECustomer: getNoFMECustomerErrorInfo({
            noFMECustomerOptions: noFMECustomerOptions[0]?.isChecked,
            equipmentDetails: prevState.deliveryDetails.equipmentDetails
          })
        }
      }
    }));
  };

  onChangeNoCargoVan = (noCargoVanCustomerOptions) => {
    this.setState((prevState) => ({
      deliveryDetails: {
        ...prevState.deliveryDetails,
        noCargoVanCustomerOptions
      }
    }));
  };

  markDefaultHoursClosed = () => {
    const fieldName = getCustomerDetailsKey(this.state.activeTab);
    this.setState((state) => ({
      [fieldName]: {
        ...state[fieldName],
        defaultHours: [closedDayTime],
        errorInfo: {
          ...state[fieldName].errorInfo,
          defaultHours: [this.getRequiredError(closedDayTime)]
        }
      }
    }));
  };

  addDayOfWeekHours = () => {
    const isDeliveriesTab = isDeliveryTab(this.state.activeTab);
    if (isDeliveriesTab) {
      this.setState((prevState) => ({
        deliveryDetails: {
          ...prevState.deliveryDetails,
          receivingHours: DAYS.reduce((receivingHours, day) => {
            receivingHours[day] = [this.state.deliveryDetails.defaultHours[0]];
            return receivingHours;
          }, {})
        }
      }));
      return;
    }
    this.setState((prevState) => ({
      pickupDetails: {
        ...prevState.pickupDetails,
        shippingHours: DAYS.reduce((dayShippingHours, day) => {
          dayShippingHours[day] = [this.state.pickupDetails.defaultHours[0]];
          return dayShippingHours;
        }, {})
      }
    }));
  };

  onChangeTab = (_event, activeTab) => {
    this.setState(
      {
        activeTab
      },
      () => {
        if (activeTab === appConstants.CUSTOMER_TAB_TYPE.DRIVER_COMMENTS) {
          this.fetchDriverCommentsIfNeeded();
        }
      }
    );
  };

  fetchDriverCommentsIfNeeded = () => {
    const { hasFetchedDriverComments, isDriverCommentsLoading, data } = this.state;
    if (hasFetchedDriverComments || isDriverCommentsLoading) {
      return;
    }
    const customerCode = data?.deliveryDetails?.originalCustomerCode;
    if (!customerCode || !this.terminalId) {
      this.handleDriverCommentsFetchError();
      return;
    }
    this.setState({ isDriverCommentsLoading: true });
    getDataWithQueryString(
      'GetDriverNotes',
      buildDriverCommentsQueryString({ terminalId: this.terminalId, customerCode })
    ).then(
      (response) => {
        if (response?.status >= 200 && response?.status < 400) {
          this.setState({
            driverComments: normalizeDriverComments(response.data),
            hasFetchedDriverComments: true,
            isDriverCommentsLoading: false
          });
          return;
        }
        this.handleDriverCommentsFetchError();
      },
      () => {
        this.handleDriverCommentsFetchError();
      }
    );
  };

  handleDriverCommentsFetchError = () => {
    this.props.enqueueSnackbar(driverCommentsConstants.MESSAGE.FETCH_DRIVER_COMMENTS_FAILURE, {
      variant: 'error'
    });
    this.setState({
      driverComments: [],
      hasFetchedDriverComments: true,
      isDriverCommentsLoading: false
    });
  };

  getCustomerDetails = () => {
    return {
      terminalId: this.terminalId,
      customerCode: this.state.data.deliveryDetails?.originalCustomerCode,
      holidays: this.state.data.holidays ?? []
    };
  };

  handleAppointment = (value) => {
    this.setState((prevState) => ({
      deliveryDetails: {
        ...prevState.deliveryDetails,
        appointmentValue: value,
        minimumHUValue: null
      }
    }));
  };

  clearAppointment = () => {
    this.setState((prevState) => ({
      deliveryDetails: {
        ...prevState.deliveryDetails,
        appointmentValue: null,
        minimumHUValue: null
      }
    }));
  };

  handleMinHU = (value) => {
    const minimumHUValue = value?.value ?? null;
    this.setState((prevState) => ({
      deliveryDetails: {
        ...prevState.deliveryDetails,
        minimumHUValue
      }
    }));
  };

  getFormInputValues = (formData) => {
    if (isDeliveryTab(formData.activeTab)) {
      return {
        defaultHours: formData.deliveryDetails.defaultHours,
        receivingHours: formData.deliveryDetails.receivingHours,
        errorInfo: formData.deliveryDetails.errorInfo,
        stopTime: formData.deliveryDetails.stopTime,
        accessorialList: formData.deliveryDetails.accessorialList
      };
    }
    return {
      defaultHours: formData.pickupDetails.defaultHours,
      receivingHours: formData.pickupDetails.shippingHours,
      errorInfo: formData.pickupDetails.errorInfo,
      stopTime: formData.pickupDetails.stopTime,
      accessorialList: formData.pickupDetails.accessorialList
    };
  };

  renderNoData = () => {
    return <div className={this.props.classes.dialogContent}>No details available</div>;
  };

  renderReceivingHours = () => {
    const { classes, configJSON } = this.props;
    const { isAdmin } = this.props.userData?.userProfile || {};
    const {
      selectedRoute,
      activeTab
    } = this.state;
    const isDeliveriesTabActive = isDeliveryTab(activeTab);
    const isRouteEditDisabled = configJSON?.enableAdminEditableRouteName && !isAdmin;
    const stateKey = isDeliveriesTabActive ? CUSTOMER_DETAILS.DELIVERY : CUSTOMER_DETAILS.PICKUP;
    
    const equipmentDetailsKey = `${activeTab}_${this.state[stateKey].equipmentDetails?.equipmentType ?? 'equipmentType'}`;
    const isPickupsTabActive = isPickupTab(activeTab);
    const showEquipmentDetails = isDeliveriesTabActive || (isPickupsTabActive && this.props.configJSON.enableEquipmentSizeForShipper);
    const { defaultHours, receivingHours, errorInfo, stopTime, accessorialList } =
      this.getFormInputValues(this.state);
    const isDefaultHoursClosed = defaultHours[0] === closedDayTime;
    const hasReceivingHours = Boolean(receivingHours);
    const enableMultipleTimeWindows =   isDeliveriesTabActive ? true : this.props.configJSON.enableMultipleShipperTimeWindows;

    return (
      <div className={classes.receivingHoursContainer}>
        <InfoHeader title={isDeliveriesTabActive ? 'Receiving Hours' : 'Shipping Hours'} />
        <Grid item>
          <DayofWeekHoursInput
            key={`${activeTab}_dayOfWeek`}
            hasHours={hasReceivingHours}
            markDefaultHoursClosed={this.markDefaultHoursClosed}
            isDefaultHoursClosed={isDefaultHoursClosed}
            defaultHoursError={errorInfo?.defaultHours}
            addDayOfWeekHours={this.addDayOfWeekHours}
            updateDefaultHours={this.updateDefaultHours}
            defaultHours={defaultHours}
            isDeliveriesTabActive={isDeliveriesTabActive}
          />
        </Grid>
        {hasReceivingHours ? (
          <>
            <ReceivingHoursRenderer
              key={activeTab}
              receivingHours={receivingHours}
              updateHours={this.updateHours}
              errorInfo={errorInfo}
              resetToDefaultHours={this.resetToDefaultHours}
              enableMultipleTimeWindows={enableMultipleTimeWindows}
              activeForm={activeTab}
              defaultHours={defaultHours}
            />
            <br />
            <br />
          </>
        ) : null}
        <Grid container className={classes.checkBoxGroupContainer}>
          {isDeliveriesTabActive && (
            <>
              {this.state.enableTrailerBackFillCustomer && (
                <CustomCheckbox
                  name="isTrailerBackFill"
                  labelText="Trailer Drop"
                  isChecked={this.state.isTrailerBackFill}
                  handleChange={this.updateTrailerBackfill}
                  tooltip="Allow trailer drop customer routes to backfill with other shipments."
                />
              )}
              {this.enableTailLoadInCustomerManagement && (
                <CustomCheckbox
                  name="isTailLoad"
                  labelText="Tail Load"
                  isChecked={this.state.isTailLoad}
                  handleChange={this.updateTailLoad}
                  tooltip="Customer requires tail load positioning on the trailer."
                />
              )}
              {this.props.configJSON.enableFMECustomer && (
                <CustomCheckboxGroupRendered
                  options={this.state[stateKey].noFMECustomerOptions}
                  onChange={this.onChangeNoFMECustomer}
                />
              )}
              {this.props.configJSON.enableNoCargoVanCustomer && (
                <CustomCheckboxGroupRendered
                  options={this.state[stateKey].noCargoVanCustomerOptions}
                  onChange={this.onChangeNoCargoVan}
                />
              )}
            </>
          )}
        </Grid>
        <Grid container className={classes.routeStopContainer}>
          {isDeliveriesTabActive && (
            <Select
              canAcceptNewValue
              newValueParams={this.props.configJSON?.routeNameEditParams}
              textFieldProps={{
                id: 'filterByRoute',
                label: 'Route',
                variant: 'outlined'
              }}
              value={selectedRoute}
              onChange={this.updateRoute}
              data={this.state.customerRoutes}
              InputLabelProps={{
                classes: {
                  root: classes.InputLabelProps
                }
              }}
              classes={{
                root: classes.selectFilterClass
              }}
              menuPosition={'fixed'}
              isDisabled={isRouteEditDisabled}
            />
          )}
          <TextField
            key={`${activeTab}_stopTime`}
            id="number"
            type="number"
            label="Stop Time"
            InputProps={{
              inputProps: { max: 500 },
              endAdornment: (
                <InputAdornment position="end">
                  <span className={classes.inputAdornment}>mins</span>
                </InputAdornment>
              ),
              className: classes.input,
              classes: {
                root: classes.inputRoot,
                notchedOutline: classes.notchedOutline
              }
            }}
            InputLabelProps={{
              classes: {
                root: classes.InputLabelProps
              }
            }}
            value={stopTime}
            onChange={this.updateStopTime}
            variant="outlined"
            autoComplete="off"
            classes={{
              root: classes.textFieldClass
            }}
          />
        </Grid>
        <div className={classes.paddingBottom}>
          <div className={classes.paddingBottom} />
          <CustomCheckboxGroupRendered
            options={accessorialList}
            onChange={this.updateAccessorials}
            isRadioType={true}
          />
        </div>
        {showEquipmentDetails && (
          <>
            <Grid item className={classes.paddingBottom}>
              <EquipmentDetails
                key={equipmentDetailsKey}
                equipmentSizeOptions={this.props.CommonStore.equipmentSizes}
                handleEquipmentSizeChange={this.updateEquipmentSize}
                equipmentDetails={this.state[stateKey].equipmentDetails}
                errorInfo={this.state[stateKey].errorInfo}
                handleEquipmentTypeChange={this.handleEquipmentTypeChange}
                enabledFixedEquipment={this.props.configJSON.enableFixedEquipmentSize}
                clearEquipmentPreference={this.clearEquipmentPreference}
              />
            </Grid>
          </>
        )}
      </div>
    );
  };
  handleEquipmentTypeChange = (value) => {
    const equipmentType = value?.value ?? null;
    const stateKey = getCustomerDetailsKey(this.state.activeTab);
    
    if (this.state[stateKey].equipmentDetails.equipmentType === equipmentType) {
      return;
    }

    this.setState((prevState) => ({
      [stateKey]: {
        ...prevState[stateKey],
        equipmentDetails: {
          equipmentType,
        }
      }
    }));
  };

  getLastModifiedDetails = () => {
    const { data, activeTab } = this.state;
    return activeTab === appConstants.CUSTOMER_TAB_TYPE.PICKUP
      ? data?.pickupDetails?.lastModified
      : data?.deliveryDetails?.lastModified;
  };

  updateContactDetails = (field, value) => {
    const fieldName = getCustomerDetailsKey(this.state.activeTab);
    this.setState((state) => {
      const updatedField = {
        ...state[fieldName],
        [field]: value
      };

      // Reset phoneNumber error if something is changed in phoneNumber field
      if (field === 'phoneNumber') {
        updatedField.errorInfo = {
          ...state[fieldName].errorInfo,
          phoneNumber: ''
        };
      }

      return { [fieldName]: updatedField };
    });
  };

  updateDeliveryDetails = (field, value) => {
    this.setState((state) => ({
      deliveryDetails: {
        ...state.deliveryDetails,
        [field]: value
      }
    }));
  };

  updatePickupDetails = (field, value) => {
    this.setState((state) => ({
      pickupDetails: {
        ...state.pickupDetails,
        [field]: value
      }
    }));
  };

  handlePhysicalDeliveryReceiptChange = (type)=> (value) => {
    if (type === appConstants.CUSTOMER_TYPE.PICKUP) {
      this.updatePickupDetails('isPhysicalDrRequired', value);
    }
    else if (type === appConstants.CUSTOMER_TYPE.DELIVERY) {
      this.updateDeliveryDetails('isPhysicalDrRequired', value);
    }
  };

  getADNEmailError = (email, isToggleOn = this.state.adnToggleEnabled) => {
    if (!this.isADNEnabled || !isToggleOn) {
      return '';
    }
    if (!email) {
      return FORM_VALIDATION_MSG.REQUIRED;
    }
    if (!isValidEmail(email)) {
      return FORM_VALIDATION_MSG.INVALID_EMAIL;
    }
    return '';
  };

  handleADNToggleChange = (value) => {
    this.setState({ adnToggleEnabled: value });
  };

  handleADNEmailChange = (email) => {
    this.setState((prevState) => ({
      adnEmail: email,
      deliveryDetails: {
        ...prevState.deliveryDetails,
        errorInfo: {
          ...prevState.deliveryDetails?.errorInfo,
          adnEmail: this.getADNEmailError(email, prevState.adnToggleEnabled)
        }
      }
    }));
  };

  getADNPayload = () => {
    const data = getADNPayload({
      isEnabled: this.isADNEnabled,
      toggleOn: this.state.adnToggleEnabled,
      email: this.state.adnEmail,
      existingEmail: this.adnExistingEmail,
    });
    if (data?.emailForAdvanceDeliveryNotification !== this.adnExistingEmail) {
      RMAXLogger.info("ADN Email changed", {
        email: data?.emailForAdvanceDeliveryNotification,
      });
    }
    return data;
  };

  renderPhysicalDrPreferenceSection = (customerType) => {
    const { classes } = this.props;
    const details =
      customerType === appConstants.CUSTOMER_TYPE.DELIVERY
        ? this.state.deliveryDetails
        : this.state.pickupDetails;
    return (
      <div className={classes.paddingBottom}>
        <SectionHeader title="DELIVERY RECEIPT" />
        <div className={classes.deliveryReceiptContainer}>
          <span>Requires paper delivery receipt</span>
          <CustomSwitch
            rowLabel=""
            value={Boolean(details?.isPhysicalDrRequired)}
            onChange={this.handlePhysicalDeliveryReceiptChange(customerType)}
          />
        </div>
      </div>
    );
  };

  renderEditForm = () => {
    const { classes } = this.props;
    const { activeTab } = this.state;
    const isDeliveriesTabActive = isDeliveryTab(activeTab);
    const isPickupsTabActive = isPickupTab(activeTab);
    const noDataCondition =
      (isDeliveriesTabActive && !this.state.data.deliveryDetails) ||
      (isPickupsTabActive && !this.state.data.pickupDetails);
    if (noDataCondition) {
      return this.renderNoData();
    }
    const tabToContentMap = {
      [appConstants.CUSTOMER_TAB_TYPE.DELIVERY]: (
        <>
          <ContactDetails
            title={CONTACT_SECTION_TITLES.DELIVERY}
            details={this.state.deliveryDetails}
            updateDetails={this.updateContactDetails}
          />
          {this.renderReceivingHours()}
          {this.isAppointmentEnabled && (
            <div className={classes.paddingBottom}>
              <SectionHeader
                title='Appointment'
                headerButtonDetails={{ label: 'Clear All', onClick: this.clearAppointment }}
              />
              <Appointment
                handleAppointmentChange={this.handleAppointment}
                handleMinHUChange={this.handleMinHU}
                appointmentValue={this.state.deliveryDetails?.appointmentValue}
                minimumHUValue={this.state.deliveryDetails?.minimumHUValue}
                configJSON = {this.props.configJSON}
              />
            </div>
          )}
          <DeliveryInstructions
            data={this.state.deliveryDetails}
            updateData={this.updateDeliveryDetails}
          />
          {this.props.configJSON.drPreferenceInCustomerManagement &&
            this.renderPhysicalDrPreferenceSection(appConstants.CUSTOMER_TYPE.DELIVERY)}

          {this.isADNEnabled && (
            <div className={classes.paddingBottom}>
              <SectionHeader title="ADVANCE DELIVERY NOTIFICATION" />
              <AdvanceDeliveryNotification
                isToggleOn={this.state.adnToggleEnabled}
                email={this.state.adnEmail}
                onToggleChange={this.handleADNToggleChange}
                onEmailChange={this.handleADNEmailChange}
                error={this.state.deliveryDetails?.errorInfo?.adnEmail}
              />
            </div>
          )}
          {this.props.configJSON.enableDispatch ? (
            <>
              <SectionHeader title={'Receiver(s)'} />
              <Receivers customerCode={this.state.data.deliveryDetails?.originalCustomerCode} />
            </>
          ) : null}
          {this.props.configJSON.enableCommentsForCustomer && (
            <>
              <Grid container>
                <Notes
                  key={activeTab}
                  value={this.state.deliveryDetails.customerComments}
                  onChange={this.handleNoteChange}
                />
              </Grid>
            </>
          )}
        </>
      ),
      [appConstants.CUSTOMER_TAB_TYPE.PICKUP]: (
        <>
          <ContactDetails
            title={CONTACT_SECTION_TITLES.PICKUP}
            details={this.state.pickupDetails}
            updateDetails={this.updateContactDetails}
            contactNameField="shipperContactName"
          />
          {this.renderReceivingHours()}
          <DeliveryInstructions
            data={this.state.pickupDetails}
            updateData={this.updatePickupDetails}
          />
          {this.props.configJSON.enableDRPreferenceInShipperManagement &&
            this.renderPhysicalDrPreferenceSection(appConstants.CUSTOMER_TYPE.PICKUP)}
          {this.props.configJSON.enableCommentsForCustomer && (
            <>
              <Grid container>
                <Notes
                  key={activeTab}
                  value={this.state.pickupDetails.shipperComments}
                  onChange={this.handleNoteChange}
                />
              </Grid>
            </>
          )}
        </>
      ),
      [appConstants.CUSTOMER_TAB_TYPE.HOLIDAY]: (
        <Holidays
          openModule={this.props.openModule}
          holidayOptions={this.props.IBPlanningStore.holidayOptions}
          refreshCustomerData={this.getCustomerManagementData}
          customerDetails={this.getCustomerDetails()}
        />
      ),
      [appConstants.CUSTOMER_TAB_TYPE.DRIVER_COMMENTS]: (
        <DriverComments
          driverComments={this.state.driverComments}
          isLoading={this.state.isDriverCommentsLoading}
        />
      ),
      [appConstants.CUSTOMER_TAB_TYPE.ALIASES]: (
        <Aliases aliases={this.state.data?.aliases} />
      )
    };
    return (
      <Grid item xs={12}>
        <div className={classes.dialogContents}>{tabToContentMap[activeTab]}</div>
      </Grid>
    );
  };

  handleSplitResizeEnd = () => {
    this.props.glEventHub.emit('mapResize');
  };

  render() {
    const { handleClose, classes, configJSON } = this.props;
    const { data, address, customerGeoFencing, activeTab, updatePending } = this.state;
    const { theme } = this.props.userData?.userProfile || {};
    const { dateTime, userName } = this.getLastModifiedDetails() ?? {};
    const hideUpdateAction = !(isDeliveryTab(activeTab) || isPickupTab(activeTab));
    return (
      <div
        className={`${(classes.dialogWrapper, classes.dialogContainer)} ${theme}`}>
        {!data ? (
          <AppLoading />
        ) : (
          <ResizableSplitLayout
            {...EDIT_CUSTOMER_FORM_MAP_SPLIT_LAYOUT}
            onResizeEnd={this.handleSplitResizeEnd}
            leftPanel={
              <div className={`${classes.formContainer} ${classes.splitLeftPanel}`}>
                <Header
                  data={data}
                  address={address}
                  handleClose={handleClose}
                  dateTime={dateTime}
                  userName={userName}
                />
                <div className={classes.tabContainer}>
                  <Tabs
                    value={activeTab}
                    onChange={this.onChangeTab}
                    textColor="primary"
                    indicatorColor="primary">
                    <Tab
                      label="Deliveries"
                      value={appConstants.CUSTOMER_TAB_TYPE.DELIVERY}
                      classes={{
                        root: classes.tabRoot,
                        selected: classes.tabSelected
                      }}
                    />
                    {configJSON?.showShippersInCustomerManagement && (
                      <Tab
                        label="Pickups"
                        value={appConstants.CUSTOMER_TAB_TYPE.PICKUP}
                        classes={{
                          root: classes.tabRoot,
                          selected: classes.tabSelected
                        }}
                      />
                    )}
                    <Tab
                      label="Holidays"
                      value={appConstants.CUSTOMER_TAB_TYPE.HOLIDAY}
                      classes={{
                        root: classes.tabRoot,
                        selected: classes.tabSelected
                      }}
                    />
                    {this.state.data?.deliveryDetails && (
                      <Tab
                        label="Driver Comments"
                        value={appConstants.CUSTOMER_TAB_TYPE.DRIVER_COMMENTS}
                        classes={{
                          root: classes.tabRoot,
                          selected: classes.tabSelected
                        }}
                      />
                    )}
                    <Tab
                      label={`Aliases (${this.state.data?.aliases?.length ?? 0})`}
                      value={appConstants.CUSTOMER_TAB_TYPE.ALIASES}
                      classes={{
                        root: classes.tabRoot,
                        selected: classes.tabSelected
                      }}
                    />
                  </Tabs>
                </div>
                <div className={`${classes.dialogContents} customScroll`}>
                  {this.renderEditForm()}
                </div>

                <Action
                  onClose={handleClose}
                  hideUpdateAction={hideUpdateAction}
                  onClick={this.updateCustomerData}
                  isLoading={updatePending}
                />
              </div>
            }
            rightPanel={
              <div className={classes.splitRightPanel}>
                <EditCustomerMap
                  activeTab={activeTab}
                  customer={data}
                  customerGeoFencing={customerGeoFencing}
                  customerGeoFencingChange={this.customerGeoFencingChange}
                  glEventHub={this.props.glEventHub}
                  gridHeaderId={this.gridHeaderId}
                />
              </div>
            }
          />
        )}
        {data && this.state.geoCodeCustomer && (
          <GeoCodingModal
            customer={this.state.geoCodeCustomer}
            userData={this.props.userData.userProfile}
            close={this.closeGeocodeModal}
          />
        )}
      </div>
    );
  }
}

export default compose(
  WithDrawer,
  withStyles(styles),
  withSnackbar,
  withUserProfile,
  withAppConfig,
  withFeatureFlags
)(CustomerManagementDialog);
